import { Lojistik } from "./lojistik";

export class LojistiklerPage {

    currentPage: number;
    pageCount: number;
    pageSize: number;
    rowCount: number;
    firstRowOnPage: number;
    lastRowOnPage: number;
    private pResults: Lojistik[];
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): Lojistik[] {
    return this.pResults;
  }

  public set results(list: Lojistik[]) {
    if (list != null) {
      this.pResults = list.map(t => new Lojistik(t));
    }
  }
}
